module.exports = __webpack_public_path__ + "img/document-copy.c2b05586.svg";